import { render, staticRenderFns } from "./SectionStateTickets.vue?vue&type=template&id=1ac54cc4&scoped=true&"
import script from "./SectionStateTickets.vue?vue&type=script&lang=js&"
export * from "./SectionStateTickets.vue?vue&type=script&lang=js&"
import style0 from "./SectionStateTickets.vue?vue&type=style&index=0&id=1ac54cc4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac54cc4",
  null
  
)

export default component.exports